import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'

export const deleteKpiUserAssignment = async (id: string): Promise<void> => {
  try {
    await axios.delete(`${BASE_URL}/kpi/user-assignments/${id}/`)
  } catch (error) {
    throw error
  }
}
